<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
      <mask
        id="help-icon-docs"
        width="24"
        height="24"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
        style="mask-type: alpha"
      >
        <path fill="inherit" stroke="none" d="M0 0h24v24H0z" />
      </mask>
      <g mask="url(#help-icon-docs)">
        <path
          fill="inherit"
          stroke="none"
          d="M11.95 18c.35 0 .65-.12.89-.36s.36-.54.36-.89-.12-.65-.36-.89a1.2 1.2 0 0 0-.89-.36c-.35 0-.65.12-.89.36a1.2 1.2 0 0 0-.36.89c0 .35.12.65.36.89s.54.36.89.36Zm-.9-3.85h1.85c0-.55.06-.98.19-1.3.12-.32.48-.75 1.06-1.3a7.5 7.5 0 0 0 1.03-1.24c.25-.39.37-.86.37-1.41a2.5 2.5 0 0 0-1.03-2.15A4 4 0 0 0 12.1 6c-.95 0-1.72.25-2.31.75-.6.5-1 1.1-1.24 1.8l1.65.65c.08-.3.27-.63.56-.97.3-.36.74-.53 1.34-.53.53 0 .93.15 1.2.44.27.29.4.61.4.96 0 .33-.1.65-.3.94-.2.29-.45.56-.75.81a6.22 6.22 0 0 0-1.35 1.47c-.17.34-.25.95-.25 1.83ZM12 22a10.1 10.1 0 0 1-9.21-6.1A9.74 9.74 0 0 1 2 12a10.1 10.1 0 0 1 6.1-9.21A9.74 9.74 0 0 1 12 2a10.1 10.1 0 0 1 9.21 6.1c.53 1.22.79 2.52.79 3.9s-.26 2.68-.79 3.9a10.1 10.1 0 0 1-5.31 5.31A9.74 9.74 0 0 1 12 22Zm0-2c2.23 0 4.13-.77 5.68-2.32A7.72 7.72 0 0 0 20 12c0-2.23-.77-4.13-2.32-5.67A7.72 7.72 0 0 0 12 4c-2.23 0-4.13.78-5.67 2.33A7.72 7.72 0 0 0 4 12c0 2.23.78 4.13 2.33 5.68A7.72 7.72 0 0 0 12 20Z"
        />
      </g>
    </svg>
  </span>
</template>
